import { useGuideStore } from "./useGuideStore";

export const isGuideSupported = (sessionId: string, guideTitle?: string) => {
    const { availableGuides } = useGuideStore.getState().getGuideSession(sessionId);
    const isGuideSupported = !!availableGuides?.find((guide) => [guideTitle].includes(guide.title));
    return isGuideSupported;
};

export const isGuideRecommendationDisabled = (sessionId: string, guideTitle?: string) => {
    const { availableGuides } = useGuideStore.getState().getGuideSession(sessionId);
    const isGuideRecommendationDisabled = !!availableGuides?.find((guide) => [guideTitle].includes(guide.title))
        ?.isGuideRecommendationDisabled;
    return isGuideRecommendationDisabled;
};
